<div class="card block isMinimizable">
    <div class="card-header">
        <div class="card-title">
            <i class="fa fa-angle-up"></i>
            <h2>Localisation</h2>
        </div>
    </div>
    <div class="card-body col-md-12">
        <img *ngIf="preview" src="assets/widgets/localisation.PNG" class="img-fluid"/>
        <div class="card-text row" *ngIf="!preview">
            <div class="col-md-8">
                <mat-form-field class="lines-2">
                    <mat-label>Adresse <i class="fa fa-info-circle" matTooltip="Dans certains cas, nos algorithmes vont trouver l’adresse d’un bien immobilier.
Cependant, cette adresse dépend des informations renseignées dans l’annonce et peut ne pas être totalement exacte. Pensez à toujours vérifier cette adresse auprès du vendeur ou de l’agent immobilier."></i></mat-label>
                    <textarea matInput placeholder="" [(ngModel)]="favorite.adress"
                              (ngModelChange)="edit($event, 'adress')"></textarea>
                </mat-form-field>
            </div>
            <div class="col-md-4">
                <mat-form-field>
                    <mat-label>Code postal</mat-label>
                    <input type="text"
                           class="text"
                           matInput
                           [(ngModel)]="favorite.ad_city.zip_code"
                           [formControl]="zipcodeControl"
                           [matAutocomplete]="autoZipcode">
                    <mat-autocomplete (optionSelected)='changeCity($event.option.value)'
                                      [displayWith]="commonService.zipcodeLabel" autoActiveFirstOption
                                      #autoZipcode="matAutocomplete">
                        <mat-option *ngFor="let city of zipCode" [value]="city">
                            {{ city.name }}
                            ({{ city.display_zip_code == '' ? city.zip_code : city.display_zip_code.includes(',') ? 'Toute la ville' : city.display_zip_code }})
                        </mat-option>
                    </mat-autocomplete>
                    <span matSuffix><div class="citySpinner" style="display: none;"><mat-spinner
                        diameter="20"></mat-spinner></div></span>
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Ville</mat-label>
                    <input type="text"
                           class="text"
                           matInput
                           [(ngModel)]="favorite.ad_city.name"
                           [formControl]="cityControl"
                           [matAutocomplete]="auto">
                    <mat-autocomplete (optionSelected)='changeCity($event.option.value)'
                                      [displayWith]="commonService.cityLabel" autoActiveFirstOption
                                      #auto="matAutocomplete">
                        <mat-option *ngFor="let city of cities" [value]="city">
                            {{ city.name }}
                            ({{ city.display_zip_code == '' ? city.zip_code : city.display_zip_code.includes(',') ? 'Toute la ville' : city.display_zip_code }})
                        </mat-option>
                    </mat-autocomplete>
                    <span matSuffix><div class="citySpinner" style="display: none;"><mat-spinner
                        diameter="20"></mat-spinner></div></span>
                </mat-form-field>
            </div>
            <div class="col-6">
                <mat-form-field>
                    <mat-label>Secteur</mat-label>
                    <mat-select disableOptionCentering [(ngModel)]="secteur" (ngModelChange)="edit($event, 'secteur')" [disabled]="favorite.ad_city.mapping_quartier_iris == null || favorite.ad_city.mapping_quartier_iris.quartier == null || favorite.ad_city.mapping_quartier_iris.quartier.length == 1">
                        <mat-option value="">Tous les secteurs</mat-option>
                        <mat-option *ngFor="let group of favorite.ad_city.mapping_quartier_iris.quartier"
                                    [value]="group.GQ_c">{{ group.GQ_n }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-6">
                <mat-form-field>
                    <mat-label>Quartier</mat-label>
                    <mat-select disableOptionCentering [(ngModel)]="favorite.iris" (ngModelChange)="edit($event)" [disabled]="cityService.getQuartier(favorite.ad_city, secteur).length == 0">
                        <mat-option [value]="secteur">Tous les quartiers</mat-option>
                        <mat-option *ngFor="let group of cityService.getQuartier(favorite.ad_city, secteur)"
                                    [value]="group.IRIS_c">{{ group.IRIS_n }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-12 mb-4" *ngIf="detectIris != '' && favorite.ad_city.mapping_quartier_iris && favorite.ad_city.mapping_quartier_iris.quartier && favorite.ad_city.mapping_quartier_iris.quartier.length > 0">
                <div class="notif notif_info w-100" *ngIf="cityService.getQuartierName('_iris' ,favorite.ad_city, detectIris)">
                    <i class="fa fa-info-circle me-2"></i>
                    Selon l’adresse indiquée, le secteur est {{ cityService.getQuartierName('_gq' ,favorite.ad_city, detectIris.substring(0, 7)) }}
                    et le quartier est {{ cityService.getQuartierName('_iris' ,favorite.ad_city, detectIris) }}.
                </div>
                <div class="notif notif_warning w-100" *ngIf="!cityService.getQuartierName('_iris' ,favorite.ad_city, detectIris)">
                    <i class="fa fa-info-circle me-2"></i>
                    Selon l’adresse indiquée, le quartier est introuvable.
                </div>
            </div>

<!--            {{ }}-->
<!--            Le nombre de ventes dans le quartier sélectionné est trop faible pour obtenir un prix/m² moyen significatif. Vous pouvez sélectionner "Tous les quartiers" ou "Tous les secteurs" pour avoir une estimation.-->

            <div class="col-12">
                <div class="data_moy">
                    <h3 class="text-center">
                        Prix au m²
                        <i *ngIf="favorite.advice_price_real == favorite.advice_price_choice" class="fa fa-info-circle" matTooltip="Prix au m² moyen  pour {{ cityService.getFullLib(favorite.advice_price_real, favorite.ad_city, favorite.iris) }}"></i>
                        <i *ngIf="favorite.advice_price_real != favorite.advice_price_choice" class="fa fa-info-circle warning" matTooltip="Le nombre de vente n'est pas suffisant pour estimer le prix précisément. Le prix au m² moyen affiché est pour {{ cityService.getFullLib(favorite.advice_price_real, favorite.ad_city, favorite.iris) }}"></i>
                    </h3>
                    <div class="row justify-content-center">
                        <div class="wrap">
                            <div class="row">
                                <div class="col-6 moy_price">
                                    <label>
                                        Moyen <i class="fa fa-info-circle"
                                                 matTooltip="Estimation basée sur les ventes immobilières enregistrées par les notaires, basée sur la localisation et la typologie du bien. Il s’agit du prix médian : 50% des logements similaires ont un prix plus faible, et 50% ont un prix plus élevé."></i>
                                    </label>
                                    <b class="value">
                                        {{ favorite.advice_price == 0 ? '-' : favorite.advice_price | number:'1.0-0' }}
                                        <span class="unit">€/m²</span>
                                    </b>
                                </div>
                                <div class="col-6 range_price">
                                    <label>
                                        Bas <i class="fa fa-info-circle"
                                               matTooltip="Estimation basée sur les ventes immobilières enregistrées par les notaires, basée sur la localisation et la typologie du bien. Il s’agit du prix bas : 25% des logements similaires ont un prix plus faible, et 75% ont un prix plus élevé."></i>
                                        :
                                    </label>
                                    <b class="value">
                                        {{ favorite.advice_price_L == 0 ? '-' : favorite.advice_price_L | number:'1.0-0' }}
                                        <span class="unit">€/m²</span>
                                    </b>
                                    <br/>
                                    <label>
                                        Haut <i class="fa fa-info-circle"
                                                matTooltip="Estimation basée sur les ventes immobilières enregistrées par les notaires, basée sur la localisation et la typologie du bien. Il s’agit du prix haut : 75% des logements similaires ont un prix plus faible, et 25% ont un prix plus élevé."></i>
                                        :
                                    </label>
                                    <b class="value">
                                        {{ favorite.advice_price_U == 0 ? '-' : favorite.advice_price_U | number:'1.0-0' }}
                                        <span class="unit">€/m²</span>
                                    </b>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 text-center confidence">
                        Indice de confiance
                        <i class="fa fa-circle{{ favorite.advice_price_cL >= 1 ? ' actif' : ''}}" aria-hidden="true"></i>
                        <i class="fa fa-circle{{ favorite.advice_price_cL >= 2 ? ' actif' : ''}}" aria-hidden="true"></i>
                        <i class="fa fa-circle{{ favorite.advice_price_cL >= 3 ? ' actif' : ''}}" aria-hidden="true"></i>
                        <i class="fa fa-circle{{ favorite.advice_price_cL >= 4 ? ' actif' : ''}}" aria-hidden="true"></i>
                        <i class="fa fa-circle{{ favorite.advice_price_cL >= 5 ? ' actif' : ''}}" aria-hidden="true"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
